// extracted by mini-css-extract-plugin
module.exports =  {"root":"_32bbee5fda--root--Tfx7I","title":"_32bbee5fda--title--SoGVB"};